/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InsuredPeopleDto } from './InsuredPeopleDto';
import type { PlanMarket } from './PlanMarket';
import type { SelfEnrollType } from './SelfEnrollType';

export type PlanSummaryDto = {
  /**
   * Ideon external_plan_id (FR-011 membership key).
   */
  externalPlanId: string;
  carrierName: string;
  carrierLogoUrl: string;
  planName: string;
  /**
   * Canonical carrier-feed plan ID (FR-012).
   */
  planId: string;
  /**
   * Omitted when unknown rather than guessed.
   */
  metalTier?: PlanSummaryDto.metalTier;
  /**
   * Omitted when unknown rather than guessed.
   */
  planType?: PlanSummaryDto.planType;
  hsaEligible: boolean;
  /**
   * decimal.js-serialized currency value. Omitted when unknown rather than shown as $0.
   */
  deductible?: string;
  /**
   * Omitted when unknown rather than shown as $0.
   */
  maxOutOfPocket?: string;
  /**
   * Family-tier deductible. Absent when the plan has no catalog match; the consumer then falls back to the individual figure above.
   */
  familyDeductible?: string;
  familyMaxOutOfPocket?: string;
  /**
   * Absent for a roster plan: what the member paid under the previous employer is unknown.
   */
  monthlyPlanCostTotal?: string;
  monthlyPlanCostEmployer?: string;
  monthlyPlanCostEmployee?: string;
  /**
   * External-link target opened in a new tab (FR-014b).
   */
  planDetailsUrl?: string;
  /**
   * New coverage: the default ticked insureds. Current coverage: the insureds the plan covered in the prior period.
   */
  coveredInsuredIds: Array<string>;
  /**
   * The prior period's covered members as they were. Present on current coverage only.
   */
  coveredPeople?: InsuredPeopleDto;
  /**
   * New coverage only.
   */
  planMarket?: PlanMarket | null;
  /**
   * New coverage only.
   */
  selfEnroll?: SelfEnrollType;
};
export namespace PlanSummaryDto {
  /**
   * Omitted when unknown rather than guessed.
   */
  export enum metalTier {
    PLATINUM = 'PLATINUM',
    GOLD = 'GOLD',
    SILVER = 'SILVER',
    BRONZE = 'BRONZE',
    EXPANDED_BRONZE = 'EXPANDED_BRONZE',
    CATASTROPHIC = 'CATASTROPHIC',
  }
  /**
   * Omitted when unknown rather than guessed.
   */
  export enum planType {
    HMO = 'HMO',
    PPO = 'PPO',
    EPO = 'EPO',
    POS = 'POS',
    INDEMNITY = 'INDEMNITY',
  }
}
